import CIMSTable from 'components/CIMSTable'
import { useActionsTableContext } from '../../ActionsTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useEdit } from './hooks/useEdit'
import { useExpand } from './hooks/useExpand'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'

export const ActionsTable: React.VFC = () => {
  const { records, refetch, fetching } = useActionsTableContext()
  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={useColumns()}
      actions={{
        header: {
          create: useCreate(),
          onReload: refetch,
        },
        row: {
          edit: useEdit(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
      expand={useExpand()}
    />
  )
}
